import { render } from "./GroupSearchPage.vue?vue&type=template&id=7b7c08c2"
import script from "./GroupSearchPage.vue?vue&type=script&lang=js"
export * from "./GroupSearchPage.vue?vue&type=script&lang=js"

import "./GroupSearchPage.vue?vue&type=style&index=0&id=7b7c08c2&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__